import React, { Component } from 'react';

class Contact extends Component {
  render() {

    if(this.props.data){
      var name = this.props.data.name;
      var street = this.props.data.address.street;
      var city = this.props.data.address.city;
      var state = this.props.data.address.state;
      var zip = this.props.data.address.zip;
      var phone= this.props.data.phone;
      var message = this.props.data.contactmessage;
    }

    return (
      <section id="contact">

         <div className="row section-head">

            <div className="three columns header-col">

               <h1><span>Get In Touch.</span></h1>

            </div>

            <div className="ten columns">

                  <p className="lead">{message}</p>

            </div>

         </div>

         <div className="row">
            <aside className="eight columns footer-widgets">
               <div className="widget widget_contact">
                   <h4>Address and Phone</h4>
                   <p className="address">
                       {name}<br />
                       {street} <br />
                       {city}, {state} {zip}<br />
                       <span>{phone}</span>
                   </p>
               </div>
            </aside>
      </div>
   </section>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/Components/Contact.js